import CardWithCTABlock from "./CardWithCTABlock.vue";

bootVue(".vue-card", CardWithCTABlock);